<script setup lang="ts">
  import { ref } from 'vue';
  import { useAuth } from '@/store/auth';
  import { useRouter } from 'vue-router';
  import analyticsCar from '@/helpers/analytics-car';
  import ButtonCustom from '@/components/components/buttonCustom.vue';
  const email = ref('');
  const password = ref('');
  const error = ref('');
  const isLoading = ref<boolean>(false);
  const { login } = useAuth();
  const route = useRouter();
  const handleLogin = async () => {
    isLoading.value = true;
    if (!email.value || !password.value) {
      error.value = 'Please fill in all fields.';
      isLoading.value = false;
      return;
    }

    try {
      await login(email.value, password.value);
      await analyticsCar.token();
      await route.push({
        name: 'calculator',
      });
      window.location.reload();
    } catch (e) {
      isLoading.value = false;
      error.value = 'Invalid credentials. Please try again.';
    }
  };
</script>

<template>
  <div class="p-2 flex min-h-screen items-center justify-center bg-gray-100">
    <div
      class="w-full max-w-md p-8 bg-white dark:border-gray-800 shadow-md rounded-md"
    >
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-6">Login</h2>

      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label for="email" class="block text-gray-700 font-medium mb-2"
            >Email</label
          >
          <input
            v-model="email"
            type="email"
            id="email"
            class="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            placeholder="Enter your email"
          />
        </div>

        <div class="mb-4">
          <label for="password" class="block text-gray-700 font-medium mb-2"
            >Password</label
          >
          <input
            v-model="password"
            type="password"
            id="password"
            class="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            placeholder="Enter your password"
          />
        </div>

        <div v-if="error" class="text-red-500 text-sm mb-4">{{ error }}</div>

        <!--        <button-->
        <!--          type="submit"-->
        <!--          class="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"-->
        <!--        >-->
        <!--          Login-->
        <!--        </button>-->
        <button-custom title="Login" :loading="isLoading" />
      </form>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
